export interface Article {
  title: string;
  body: string;
  source: string;
  link: string;
}

export enum Sources {
  ZD_RESOURCE_CENTER = 'Resource Center',
  ZD_COMMUNITY_POST = 'Community',
  CL_GROUP = 'Group',
  CL_PODCAST = 'Podcast',
  CL_VIDEO = 'Video',
  OPEN_API = 'Developer Center',
}
